import { render } from "./IconEmail.vue?vue&type=template&id=b14879c8"
import script from "./IconEmail.vue?vue&type=script&lang=ts"
export * from "./IconEmail.vue?vue&type=script&lang=ts"
script.render = render

export default script